export default "__VITE_ASSET__6tVFDnxp__"